import { Box } from '@mui/material';

import type { FactsheetDetails } from '@/features/Factsheet/types';
import { parseVersionHistoryText } from '@/features/Factsheet/utils/versionHistory';

import TextLinesDisplay from './TextLinesDisplay';

interface CriteriaTabProps {
  factsheet: FactsheetDetails;
}

const CriteriaTab = ({ factsheet }: CriteriaTabProps) => {
  const criteriaLines = parseVersionHistoryText(factsheet, 'criteriaForInclusion');

  return (
    <Box>
      <TextLinesDisplay lines={criteriaLines} />
    </Box>
  );
};

export default CriteriaTab;
